export const jolieConfig = {
	displayScale: 0.5,
	speedPxPerSecond: 46,
	walkMinMs: 3000,
	walkMaxMs: 6500,
	idleMinMs: 3000,
	idleMaxMs: 7000,
	// Probability of sleeping at the end of a walk (0–1).
	sleepChance: 0.5,
	sleepMinMs: 6000,
	sleepMaxMs: 14000,
	minimumTravelPx: 80,
	edgePaddingPx: 12,
	entrance: {
		fallHeightPx: 140,
		landingInsetPx: 180,
		idleDurationScale: 0.5,
	},
	// Body bounds relative to the ground anchor, in original sprite pixels.
	bodyHalfWidth: 72,
	bodyHeight: 174,
	maximumHalfWidth: 110,
	proximityPx: {
		alert: 220,
		watch: 150,
		ready: 85,
		scratch: 25,
	},
	// Avoid flickering between poses or directions near a boundary.
	hysteresisPx: 8,
	facingDeadZonePx: 6,
	maxFrameDeltaMs: 50,
};
